import React, { Component } from "react";

class VideoItem extends Component {
  render() {
    const isComplete = this.props.isComplete;
    const isActive = this.props.isActive;
    let isCompleteHtml = <div className="side-menu-clip-unwatched-icon ps-color-bg-gray-04 rounded-circle" />;
    if (isComplete) {
      isCompleteHtml = <div className="side-menu-clip-watched-icon ps-color-bg-gray-04 rounded-circle" />;
    }

    return (
      <li
        onClick={this.props.videoClicked}
        className={
          "d-flex ps-color-bg-gray-05 py-sm pr-lg mx-0 clip-bg side-menu-clip ps-color-gray-02 " +
          (isActive ? "active" : "")
        }
      >
        <div className="d-flex side-menu-clip-progress justify-content-center align-items-center">{isCompleteHtml}</div>
        <h3 className="m-0 p-0 ps-type-xs ps-type-weight-book side-menu-clip-title ps-type-ellipsis">
          {this.props.title}
        </h3>
        <div className="pl-tiny ps-type-xs ps-type-weight-book side-menu-clip-duration">{this.props.time}</div>
      </li>
    );
  }
}

export default VideoItem;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoItem/VideoItem.js